import { useCurrencyStore } from "@stores/currency";

export const formatCurrency = (
    amount: number,
    options?: { currency?: string; minFraction?: number; maxFraction?: number }
): string => {
    const currency = options?.currency ?? useCurrencyStore.getState().currency;
    return new Intl.NumberFormat("en-PK", {
        style: "currency",
        currency,
        minimumFractionDigits: options?.minFraction ?? 0,
        maximumFractionDigits: options?.maxFraction ?? 0,
    }).format(amount);
};

export const formatDate = (date: string | Date): string => {
    return new Intl.DateTimeFormat("en-PK", {
        year: "numeric",
        month: "short",
        day: "numeric",
    }).format(new Date(date));
};

export const formatDateTime = (date: string | Date): string => {
    return new Intl.DateTimeFormat("en-PK", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(new Date(date));
};
